import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Download, Gift, Lock } from 'lucide-react';
export function OpeningLead() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) {
      cta.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Plan B Migratorio',
        content_type: 'product',
        value: 6.95,
        currency: 'USD'
      });
    }
    window.open('https://www.simplementemejor.com/cart/51755419697432:1', '_blank');
  };
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="pt-12 pb-8 md:pb-16 px-4 md:px-6 w-full relative bg-[var(--bg-deep)] overflow-hidden" data-id="element-277">
      {/* Subtle background glow (not distracting) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[60vh] pointer-events-none z-0" style={{
      background: 'radial-gradient(ellipse 60% 80% at 50% 0%, rgba(212,136,58,0.08) 0%, transparent 70%)'
    }} data-id="element-278" />

      <motion.div variants={container} initial="hidden" animate="show" className="max-w-[640px] mx-auto text-center relative z-10 flex flex-col items-center" data-id="element-279">
        {/* Label */}
        <motion.div variants={item} data-id="element-280">
          <p className="text-[var(--accent)] font-bold tracking-widest uppercase text-xs md:text-sm mb-1.5 md:mb-3" data-id="element-281">
            🛫 Guía de Relocalización Legal
          </p>
        </motion.div>

        {/* Headline */}
        <motion.div variants={item} data-id="element-282">
          <h1 className="md:text-5xl lg:text-6xl font-serif font-bold text-[var(--text-heading)] mb-2 md:mb-4 text-[36px]" data-id="element-283">
            Plan B Migratorio
          </h1>
        </motion.div>

        {/* Subtitle */}
        <motion.div variants={item} data-id="element-284">
          <p className="text-lg md:text-2xl text-[var(--accent)] font-serif italic mb-2 md:mb-4" data-id="element-285">
            Cómo salir de EE.UU. y reconstruir tu vida legalmente en otro país.
          </p>
        </motion.div>

        {/* Positioning */}
        <motion.div variants={item} data-id="element-286">
          <p className="text-sm md:text-base text-[var(--text-muted)] leading-relaxed max-w-xl mx-auto mb-6 md:mb-10" data-id="element-287">
            Tu salida estratégica de las sombras: convierte tus ahorros en
            dólares en residencia legal inmediata en los 5 países que compiten
            por gente como tú.
          </p>
        </motion.div>

        {/* Book Image (3D Book Mockup) */}
        <motion.div variants={item} className="mb-6 md:mb-10 relative" style={{
        perspective: '800px'
      }} data-id="element-288">
          {/* Soft gold glow underneath the book (reflection) */}
          <div className="absolute bottom-[-12px] left-1/2 -translate-x-1/2 w-[75%] h-10 pointer-events-none z-0" style={{
          background: 'radial-gradient(ellipse at center, rgba(212,136,58,0.35) 0%, rgba(212,136,58,0.1) 50%, transparent 80%)',
          filter: 'blur(18px)'
        }} data-id="element-289" />

          {/* The 3D book itself */}
          <motion.div animate={{
          y: [0, -10, 0],
          rotateY: [-2, 2, -2]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          transformStyle: 'preserve-3d'
        }} className="relative z-10" data-id="element-290">
            <img src="https://cdn.magicpatterns.com/uploads/3n4ds5BYVTxsq9t4FEGGRH/cover_2.png" alt="Plan B Migratorio" className="w-40 md:w-64 mx-auto drop-shadow-[0_20px_50px_rgba(212,136,58,0.3)] rounded-lg" data-id="element-291" />
          </motion.div>
        </motion.div>

        {/* Price Display */}
        <motion.div variants={item} className="mb-3 md:mb-5 flex flex-col items-center" data-id="element-292">
          <div className="flex items-baseline justify-center gap-3" data-id="element-293">
            <span className="text-xl md:text-2xl text-[var(--text-muted)] line-through decoration-[var(--red-emphasis)]/60 opacity-70" data-id="element-294">
              $35
            </span>
            <span className="text-4xl md:text-5xl font-serif font-bold text-[var(--text-heading)]" data-id="element-295">
              $6.95
            </span>
          </div>
          <p className="text-[var(--accent)] text-xs font-bold uppercase tracking-widest mt-1" data-id="element-296">
            -80% OFF Hoy
          </p>
        </motion.div>

        {/* CTA Button */}
        <motion.div variants={item} className="w-full sm:w-auto mb-3 md:mb-4" data-id="element-297">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto px-6 md:px-10 py-3.5 md:py-4 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#110608] font-extrabold text-sm md:text-lg rounded-xl shadow-[0_8px_25px_rgba(212,136,58,0.3)] flex items-center justify-center gap-2 whitespace-nowrap" data-id="element-298">
            <Lock className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" data-id="element-299" />
            <span className="uppercase tracking-wide" data-id="element-300">
              ACTIVAR MI PLAN B — $6.95
            </span>
          </motion.button>
        </motion.div>

        {/* Social Proof */}
        <motion.div variants={item} className="mb-3 md:mb-6" data-id="element-301">
          <div className="flex flex-col items-center gap-1.5" data-id="element-302">
            <div className="flex items-center gap-1" data-id="element-303">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[var(--accent)] text-[var(--accent)]" data-id="element-304" />)}
            </div>
            <p className="text-sm text-[var(--text-primary)] font-medium" data-id="element-305">
              +5,000 personas ya activaron su Plan B
            </p>
          </div>
        </motion.div>

        {/* Trust Badges */}
        <motion.div variants={item} data-id="element-306">
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4 text-xs text-[var(--text-muted)]" data-id="element-307">
            <span className="flex items-center gap-1.5" data-id="element-308">
              <Download className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-309" />
              Descarga digital instantánea
            </span>
            <span className="hidden md:inline opacity-30" data-id="element-310">·</span>
            <span className="flex items-center gap-1.5" data-id="element-311">
              <Gift className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-312" />
              Guía completa + bonos
            </span>
            <span className="hidden md:inline opacity-30" data-id="element-313">·</span>
            <span className="flex items-center gap-1.5" data-id="element-314">
              <ShieldCheck className="w-3.5 h-3.5 text-[var(--accent)]" data-id="element-315" />
              Garantía 30 días
            </span>
          </div>
        </motion.div>
      </motion.div>
    </section>;
}